import type { State } from '@src/redux/configureStore'

export const getAutoCompleteRespType = (state: State) =>
  state.autocomplete.autoCompleteRespType
export const getSearchQuery = (state: State) => state.autocomplete.searchQuery
export const getSearchData = (state: State) => state.autocomplete.searchData
export const getSqlQueryUserUsage = (state: State) =>
  state.autocomplete.sqlQueryUserUsage

export const GetAutocompleteTable = (state: State) => state.autocomplete.table
export const getIsPending = (state: State) => state.autocomplete.isPending
export const getBatchSize = (state: State) => state.autocomplete.batchSize
export const getHasNext = (state: State) => state.autocomplete.hasNext
export const getHasPrev = (state: State) => state.autocomplete.hasPrev
